module.exports = __webpack_public_path__ + "79f5e833063bd3e49985c8361d43b651.svg";